"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchStackQuery = exports.fetchStackEntry = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _polarisClientUtils = require("@noths/polaris-client-utils");
var _stackConfig = require("./stackConfig");
var _url = require("./url");
var CONTENTSTACK_TIMEOUT = 2000;
var fetchFromContentstack = function fetchFromContentstack(env, stackName, url) {
  var headers = {
    api_key: _stackConfig.stackConfig[stackName].apiKey,
    access_token: _stackConfig.stackConfig[stackName].envs[env].token
  };
  return (0, _polarisClientUtils.fetchJSONWithTimeout)(url, {
    headers,
    timeout: CONTENTSTACK_TIMEOUT
  });
};
var contentNotPublishedStatusCode = 422;
var fetchStackEntry = exports.fetchStackEntry = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var contentType, entryId, env, _ref$include, include, _ref$only, only, stackName, url, response, data;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          contentType = _ref.contentType, entryId = _ref.entryId, env = _ref.env, _ref$include = _ref.include, include = _ref$include === void 0 ? [] : _ref$include, _ref$only = _ref.only, only = _ref$only === void 0 ? [] : _ref$only, stackName = _ref.stackName;
          url = (0, _url.getContentstackURL)({
            contentType,
            entryId,
            env: _stackConfig.stackConfig[stackName].envs[env].name,
            include,
            only
          });
          _context.prev = 2;
          _context.next = 5;
          return fetchFromContentstack(env, stackName, url);
        case 5:
          response = _context.sent;
          if (!(response.status === contentNotPublishedStatusCode)) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", null);
        case 8:
          if (response.ok) {
            _context.next = 10;
            break;
          }
          throw new Error("failed to get content by entry ID: url ".concat(url, " status:").concat(response.status));
        case 10:
          _context.next = 12;
          return response.json();
        case 12:
          data = _context.sent;
          return _context.abrupt("return", data.entry);
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 16]]);
  }));
  return function fetchStackEntry(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchStackQuery = exports.fetchStackQuery = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref3) {
    var contentType, env, _ref3$include, include, _ref3$only, only, query, stackName, url, response, data;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          contentType = _ref3.contentType, env = _ref3.env, _ref3$include = _ref3.include, include = _ref3$include === void 0 ? [] : _ref3$include, _ref3$only = _ref3.only, only = _ref3$only === void 0 ? [] : _ref3$only, query = _ref3.query, stackName = _ref3.stackName;
          url = (0, _url.getContentstackURL)({
            contentType,
            env: _stackConfig.stackConfig[stackName].envs[env].name,
            query,
            include,
            only
          });
          _context2.prev = 2;
          _context2.next = 5;
          return fetchFromContentstack(env, stackName, url);
        case 5:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 8;
            break;
          }
          throw new Error("failed to get content by query: url ".concat(url, " status:").concat(response.status));
        case 8:
          _context2.next = 10;
          return response.json();
        case 10:
          data = _context2.sent;
          return _context2.abrupt("return", Array.isArray(data.entries) && data.entries[0] || null);
        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", Promise.reject(_context2.t0));
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 14]]);
  }));
  return function fetchStackQuery(_x2) {
    return _ref4.apply(this, arguments);
  };
}();